exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/dfm/cryosoft/ui/src/app/layouts/dashboard-layout/dashboard-layout.component.scss
// module id = ../../../../../src/app/layouts/dashboard-layout/dashboard-layout.component.scss
// module chunks = main